<template>
    <div>
        <v-dialog v-model="dialog" max-width="500px" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
            <invalidate-password-form :value="userId" @cancel="dialog = false" @save="onInvalidation" />
        </v-dialog>
        <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="auditorForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'" :set-api-data="setApiData">
            <template v-slot:expand="{ refreshKey }">
                <component :is="auditor" v-if="$route.name == 'auditEditor'" :item-id="itemId" :refresh-key="refreshKey" :filter="filter" />
            </template>
            <template v-slot:tabs>
                <v-row>
                    <v-col>
                        <v-btn-toggle mandatory class="ml-2 float-right" tile color="deep-purple accent-3" group>
                            <v-btn @click="toggleTabs(false)"> Active </v-btn>
                            <v-btn @click="toggleTabs(true)"> Inactive </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>
            </template>
            <template v-slot:buttons="{ item }">
                <v-btn @click="resendEmail(item.id)"><v-icon>mdi-email</v-icon></v-btn>
                <v-btn v-if="!displayInactive" @click="invalidatePassword(item.id)"><v-icon>mdi-key-remove</v-icon></v-btn>
            </template>
        </table-base>
    </div>
</template>

<script>
    import axios from "axios"

    export default {
        props: [
            'filter'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
            invalidatePasswordForm: () => import('@/forms/InvalidatePasswordForm')
        },
        data() {
            return {
                auditorForm: () => import('../forms/AuditorForm'),
                auditor: () => import('../editViews/Auditor'),
                headers: [
                    { text: 'Email Address', value: 'emailAddress' },
                    { text: 'Name', value: 'name' },
                    { text: 'Exemplar Global Number', value: 'exemplarGlobalNumber' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    items: []
                },
                sorting: [
                    { column: "name", direction: "ascending" },
                    { column: "emailAddress", direction: "ascending" },
                    { column: "exemplarGlobalNumber", direction: "ascending" }
                ],
                itemsField: 'auditors',
                editPageName: 'auditor',
                apiMethod: 'Auditors',
                claimName: 'Auditors',
                formTitle: 'Auditor',
                excelTitle: 'Auditors',
                hasEditPage: false,
                userId: null,
                dialog: false,
                refreshKey: 0,
                displayInactive: false
            }
        },
        methods: {
            async resendEmail(id) {
                let userId = (await axios.get("/api/Auditors/GetUserId/" + id)).data;
                await axios.get("/api/Users/ResendEmail/" + userId);
            },
            async invalidatePassword(id) {
                this.userId = (await axios.get("/api/Auditors/GetUserId/" + id)).data;
                this.dialog = true;
            },
            onInvalidation() {
                this.dialog = false;
                this.refreshKey++;
            },
            async toggleTabs(displayInactive) {
                this.displayInactive = displayInactive;
                this.refreshKey += 1;
            },
            setApiData(data) {
                this.$set(this.apiData, 'items', data.items.filter(i => this.displayInactive ? i.isInactive : !i.isInactive));
            }
        },
    };
</script>
